import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { ref, markRaw, reactive, computed } from 'vue'
  import yLogin from './login.vue'
  import yRegister from './register.vue'
  import yForget from './forget.vue'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    comp: {
      type: String,
      default: 'login',
    },
  },
  emits: ['update:visible', 'update:comp'],
  setup(__props, { emit }) {

const props = __props;

  
  
  const handleClose = () => {
    emit('update:visible', false)
  }
  const component = computed(() => {
    const { comp } = props
    switch (comp) {
      case 'register':
        return markRaw(yRegister)
      case 'forget':
        return markRaw(yForget)
      case 'login':
        return markRaw(yLogin)
    }
  })
  const handleChange = (type: any) => {
    emit('update:comp', type)
  }

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: props.visible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.visible) = $event)),
      onClose: handleClose,
      center: "",
      title: "",
      width: "400px",
      "custom-class": "login-dialog",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
          onChange: handleChange,
          onClose: handleClose
        }, null, 32))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})